import BaseEndpoint from '@/api/endpoints/base-endpoint'

export default class CertificatesEndpoint extends BaseEndpoint {}
